import * as React from 'react';
import { observer } from 'mobx-react-lite';
import PictureModel from '../../../../../model/picture/PictureModel';
import { Typography } from 'antd';
import Image from '../Image';
import { useTranslation } from 'react-i18next';
import SiteMapModel from '../../../../../../Sitemap/models/SiteMapModel';

const { Text } = Typography;

interface FCProps {}

const YourWebsiteImagesTab: React.FC<FCProps> = observer(({}) => {
  const { t } = useTranslation();

  if (SiteMapModel.externalSiteMapFething) {
    return (
      <div>
        <Text>{t('Fetching images from your website, please wait...')}</Text>
      </div>
    );
  }

  if (
    PictureModel.uploadedPictures.length === 0 &&
    SiteMapModel.oldWebsiteImages.length === 0
  ) {
    return (
      <div>
        <Text>
          {t(
            "Your uploaded images will appear in this tab. You haven't uploaded any images yet."
          )}
        </Text>
      </div>
    );
  }

  return (
    <div className="flex flex-row flex-wrap justify-between gap-2">
      {PictureModel.uploadedPictures.map((picture) => {
        return (
          <Image
            key={picture.ObjectURL}
            type="uploaded"
            mediaId={null}
            src={picture.PresignedUrl}
          />
        );
      })}
      {SiteMapModel.oldWebsiteImages.map((picture) => {
        return (
          <Image
            key={'oldwebsite-' + picture}
            type="uploaded"
            mediaId={null}
            src={picture}
          />
        );
      })}
    </div>
  );
});

export default YourWebsiteImagesTab;
